import React from 'react'
import { Mutation } from 'react-apollo'
import { FORGOT } from 'operations/User'
import { Input, Submit, Fieldset } from 'components/Form'
import { Link } from 'react-router-dom'

export default class Forgot extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            username: '',
            error: '',
            success: false
        }
    }

    handleChange(e) {
        const { name, value } = e.target
        this.setState({
            [name]: value
        })
    }

    render() {

        const errors = {
            USER_NOT_FOUND: `Sorry, that user doesn't exist.`,
            BAD_PASSWORD: 'Please check your username and password.',
            DEFAULT: `Sorry, we're having trouble logging you in.`
        }

        if (this.state.success) {
            return (
                <React.Fragment>
                    <h1>Email sent</h1>
                    <p>Check your <strong>{ this.state.username }</strong> inbox for instructions on how to reset your password.</p>
                </React.Fragment>
            )
        }

        return(

            <Mutation mutation={ FORGOT }>
            {(forgotPassword, { data }) => (

                <form onSubmit={
                    (e) => {
                        e.preventDefault()
                        forgotPassword({ variables: { data: { email: this.state.username } } })
                        .then(({ data }) => {
                            this.setState({
                                success: true
                            })
                        })
                        .catch(err => {
                            this.setState({
                                error: err.message.replace("GraphQL error: ", "")
                            })
                        })
                    }
                }>

                    {/* <div className='unauthorized__tagline'> */}
                    <h1>Reset your password</h1>
                    {/* </div> */}

                    {/* <div className='unauthorized__card'> */}

                    <Fieldset legend="This will only take a second">
                        <Input type='text' name='username' label='Your email' onChange={ this.handleChange.bind(this) } /> 

                        <div className='form__error'>{ this.state.error ? errors[this.state.error] ? errors[this.state.error] : errors.DEFAULT : '' }</div>

                        <Submit value='Get a reset link' />

                        <div className='form__switch'>
                            Remember your password now? <Link to='/'>Log in</Link>
                        </div>
                    </Fieldset>

                    {/* </div> */}

                </form>
            )}
            </Mutation>
        )

    }

}


// WEBPACK FOOTER //
// ./src/containers/Unauthorized/Forgot/index.js